// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25OYL","largestCol":"styles_largestCol__3B_QG","smallestCol":"styles_smallestCol__2EUnA"};